<template>
  <b-container fluid>
    <iq-card>
        <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('report_monthly.burnt_victim_monthly_report') }} {{ $t('globalTrans.search') }}</h4>
        </template>
        <template v-slot:body>
                <ValidationObserver ref="form" v-slot="{ handleSubmit, reset }">
                    <b-form @submit.prevent="handleSubmit(searchData)" @reset.prevent="reset">
                        <b-row>
                        <!-- fiscal_year -->
                            <b-col xl="4" lg="4" md="6" sm="12" xs="12">
                                <ValidationProvider name="Fiscal Year" vid="fiscal_year_id" rules="required|min_value:1">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="fiscal_year_id"
                                    slot-scope="{ valid, errors }"
                                >
                                    <template v-slot:label>
                                        {{ $t('globalTrans.fiscal_year') }} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                        plain
                                        v-model="search.fiscal_year_id"
                                        :options="fiscalYearList"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                        {{ errors[0] }}
                                    </div>
                                </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col xl="4" lg="4" md="6" sm="12" xs="12">
                                <ValidationProvider name="Month" vid="month_id" rules="required|min_value:1">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="month_id"
                                        slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                        {{$t('production_store.month')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                        plain
                                        v-model="search.month_id"
                                        :options="monthList"
                                        id="month_id"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                        {{ errors[0] }}
                                    </div>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col xl="4" lg="4" md="6" sm="12" xs="12" v-if="sysCall === 0">
                                <b-form-group
                                class="row"
                                label-cols-sm="4"
                                :label="$t('globalTrans.division')"
                                label-for="division_id"
                                >
                                <b-form-select
                                    plain
                                    v-model="search.division_id"
                                    :options="divisionList"
                                    id="division_id"
                                    >
                                    <template v-slot:first>
                                    <b-form-select-option :value="0" >{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                </b-form-select>
                                </b-form-group>
                            </b-col>
                            <b-col xl="4" lg="4" md="6" sm="12" xs="12" v-if="sysCall === 0">
                                <b-form-group
                                class="row"
                                label-cols-sm="4"
                                :label="$t('globalTrans.district')"
                                label-for="district_id"
                                >
                                <b-form-select
                                    plain
                                    v-model="search.district_id"
                                    :options="districtList"
                                    id="district_id"
                                    >
                                    <template v-slot:first>
                                    <b-form-select-option :value="0" >{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                </b-form-select>
                                </b-form-group>
                            </b-col>
                            <!-- Hospital Name -->
                            <b-col xl="4" lg="4" md="6" sm="12" xs="12">
                                <ValidationProvider name="Hospital Name" vid="hospital_id" rules="required|min_value:1">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="hospital_id"
                                        slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                        {{$t('social_service.hospital_name')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                        plain
                                        v-model="search.hospital_id"
                                        :options="hospitalList"
                                        id="hospital_id"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                        {{ errors[0] }}
                                    </div>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col xl="12" lg="12" md="12" sm="12" xs="12">
                                <b-button type="submit" :disabled="isDisabled" variant="primary">{{ $t('globalTrans.search')}}</b-button>
                            </b-col>
                        </b-row>
                    </b-form>
                </ValidationObserver>
        </template>
    </iq-card>
    <b-row>
      <b-col md="12" v-if="unitLoad">
        <iq-card>
            <template v-slot:body>
                <b-overlay :show="loadingState">
                    <b-col xs="12" sm="12" md="12" class="text-right mt-4" style="margin-left: -5px">
                        <b-button-group>
                            <b-button @click="pdfExport" variant="success"><i style="font-size: 18px; margin: 0; padding: 0;" class="ri-printer-fill"></i></b-button>
                        </b-button-group>
                    </b-col>
                    <!-- Report Head Data -->
                    <b-row v-if="reportHeadData">
                        <b-col xs="12" sm="12" md="3" class="text-right mt-4">
                            <b-img :src="`${ reportHeadData.reportHeadColumn[0].image }`" fluid alt="BD Image" style="width:35%;border-radius:50%;"></b-img>
                        </b-col>
                        <b-col xs="12" sm="12" md="6" class="text-center mt-2">
                            <h3 class="text-bold">
                                {{ $t('production_store.govt_info') }}
                            </h3>
                            <h4 class="text-center text-dark">
                                {{ $t('social_service.dss') }}
                            </h4>
                            <!-- <h4 class="text-center text-dark">
                                {{ reportHeadData.organizationName }}
                            </h4> -->
                            <!-- <span class="text-center text-dark">
                                {{ reportHeadData.heading }}
                            </span><br> -->
                            <span class="text-center text-dark">
                                {{ reportHeadData.address }}
                            </span><br>
                            <div class="titleDiv">
                                <span class="text-center text-dark reportTitle" style="font-weight:bold;">{{ $t('report_monthly.burnt_victim_monthly_report') }}</span><br>
                            </div>
                        </b-col>
                        <b-col xs="12" sm="12" md="3" class="text-left mt-4">
                            <b-img :src="`${ reportHeadData.reportHeadColumn[1].image }`" fluid alt="BD Image" style="width:35%;border-radius:50%;"></b-img>
                        </b-col>
                        <b-col xs="12" sm="12" md="12" class="mt-4 mb-1">
                            <b-row>
                                <b-col xs="12" sm="12" md="12" class="text-left">
                                    <span class="text-center text-dark">{{ $t('report_monthly.workplace_name') }}: <b>{{ getHospitalName(parseInt(titleData.hospital_id)) }}</b></span>
                                    <span class="text-center text-dark ml-4">{{ $t('globalTrans.fiscalYear') }}: <b>{{ getFiscalYearName(parseInt(titleData.fiscal_year_id)) }}</b></span>
                                    <span class="text-center text-dark ml-4">{{ $t('globalTrans.month') }}: <b>{{ getMonthName(parseInt(titleData.month_id)) }}</b></span>
                                    <span class="text-center text-dark ml-4">{{ $t('globalTrans.division') }}: <b>{{ parseInt(titleData.division_id) ? getDivisionName(parseInt(titleData.division_id)) : $t('globalTrans.all') }}</b></span>
                                    <span class="text-center text-dark ml-4">{{ $t('globalTrans.district') }}: <b>{{ parseInt(titleData.district_id) ? getDistrictName(parseInt(titleData.district_id)) : $t('globalTrans.all') }}</b></span>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                    <b-row class="details_report">
                        <b-col lg="12" xs="12" md="12">
                            <b-table-simple small bordered hover responsive>
                              <b-tr>
                                <b-th colspan="3">{{ $t('report_monthly.previous_month_benefited_amount') }}</b-th>
                                <b-th rowspan="2">{{ $t('report_monthly.allotment_amount_received') }}</b-th>
                                <b-th rowspan="2">{{ $t('report_monthly.sum_of_total_deposit') }}</b-th>
                                <b-th rowspan="2">{{ $t('report_monthly.withdrawal_from_bank') }}</b-th>
                                <b-th :colspan="subServiceTypeList.length + 1">{{ $t('report_monthly.reporting_month_expense') }}</b-th>
                                <b-th colspan="3">{{ $t('report_monthly.amount_of_end_month') }}</b-th>
                              </b-tr>
                              <b-tr>
                                <b-th>{{ $t('report_monthly.cash_in_hand') }}</b-th>
                                <b-th>{{ $t('report_monthly.bank_deposit') }}</b-th>
                                <b-th>{{ $t('report_monthly.total_cash_surplus_one') }}</b-th>
                                <b-th v-for="(item, index) in subServiceTypeList" :key="index">{{ $i18n.locale === 'bn' ? item.text_bn : item.text_en }}</b-th>
                                <!-- <b-th>{{ $t('report_monthly.medicine') }}</b-th>
                                <b-th>{{ $t('report_monthly.different_type_test') }}</b-th>
                                <b-th>{{ $t('report_monthly.blood_cloth') }}</b-th>
                                <b-th>{{ $t('report_monthly.wheel_chair_and_products') }}</b-th>
                                <b-th>{{ $t('report_monthly.milk_diet') }}</b-th>
                                <b-th>{{ $t('report_monthly.transportation_fair_deadbody_burial_ritual') }}</b-th>
                                <b-th>{{ $t('report_monthly.dialisis_therapy') }}</b-th>
                                <b-th>{{ $t('report_monthly.others_help') }}</b-th> -->
                                <b-th>{{ $t('report_monthly.total_cash_expenditure') }}</b-th>
                                <b-th>{{ $t('report_monthly.cash_in_hand') }}</b-th>
                                <b-th>{{ $t('report_monthly.bank_deposit') }}</b-th>
                                <b-th>{{ $t('report_monthly.total_cash_surplus_two') }}</b-th>
                              </b-tr>
                              <b-tr>
                                <b-th>{{ $n(1) }}</b-th>
                                <b-th>{{ $n(2) }}</b-th>
                                <b-th>{{ $n(3) }}</b-th>
                                <b-th>{{ $n(4) }}</b-th>
                                <b-th>{{ $n(5) }}</b-th>
                                <b-th>{{ $n(6) }}</b-th>
                                <b-th>{{ $n(7) }}</b-th>
                                <b-th>{{ $n(8) }}</b-th>
                                <b-th>{{ $n(9) }}</b-th>
                                <b-th>{{ $n(10) }}</b-th>
                                <b-th>{{ $n(11) }}</b-th>
                                <b-th>{{ $n(12) }}</b-th>
                                <b-th>{{ $n(13) }}</b-th>
                                <b-th>{{ $n(14) }}</b-th>
                                <b-th>{{ $n(15) }}</b-th>
                                <b-th>{{ $n(16) }}</b-th>
                                <b-th>{{ $n(17) }}</b-th>
                                <b-th>{{ $n(18) }}</b-th>
                              </b-tr>
                              <b-tr>
                                  <b-td>{{ $n(report_data.till_p_month_deposit.cash_in_hand) }}</b-td>
                                  <b-td>{{ $n(report_data.till_p_month_deposit.bank_deposit) }}</b-td>
                                  <b-td>{{ $n(report_data.till_p_month_deposit.total_cash_deposit) }}</b-td>
                                  <b-td>{{ $n(report_data.reported_month_deposit) }}</b-td>
                                  <b-td>{{ $n(report_data.reported_month_total_deposit) }}</b-td>
                                  <b-td>{{ $n(report_data.reported_month_withdraw) }}</b-td>

                                  <b-td v-for="(item, index) in subServiceTypeList" :key="index">
                                      {{ $n(getExpenseAmount(item.value)) }}
                                  </b-td>
                                  <b-td>{{ $n(getTotalExpense()) }}</b-td>

                                  <b-td>{{ $n(report_data.till_c_month_deposit.cash_in_hand) }}</b-td>
                                  <b-td>{{ $n(report_data.till_c_month_deposit.bank_deposit) }}</b-td>
                                  <b-td>{{ $n(report_data.till_c_month_deposit.total_cash_deposit) }}</b-td>
                              </b-tr>
                            </b-table-simple>
                            <b-table-simple small bordered hover responsive>
                              <b-tr>
                                <b-th :colspan="subServiceTypeList.length + 1">{{ $t('report_monthly.no_of_benefited_patient') }}</b-th>
                                <b-th colspan="5">{{ $t('report_monthly.total_benefited_patient_gender') }}</b-th>
                                <b-th rowspan="3"> {{ $t('report_monthly.total_income_from_start') }} </b-th>
                                <b-th rowspan="3"> {{ $t('report_monthly.total_expense_from_start') }} </b-th>
                                <b-th rowspan="3"> {{ $t('report_monthly.total_patient_from_start') }} </b-th>
                                <b-th rowspan="3">{{ $t('social_service.comment') }}</b-th>
                              </b-tr>
                              <tr>
                                <b-th rowspan="2" v-for="(item, index) in subServiceTypeList" :key="index">{{ $i18n.locale === 'bn' ? item.text_bn : item.text_en }}</b-th>
                                <b-th rowspan="2">{{ $t('report_monthly.sum_of_total_beneficiary_patient') }}</b-th>
                                <b-th rowspan="2">{{ $t('report_monthly.women') }}</b-th>
                                <b-th rowspan="2">{{ $t('report_monthly.man') }}</b-th>
                                <b-th colspan="3">{{ $t('report.baby') }}</b-th>
                              </tr>
                              <tr>
                                <b-th>{{ $t('social_service.boy') }}</b-th>
                                <b-th>{{ $t('social_service.girl') }}</b-th>
                                <b-th>{{ $t('social_service.total_child') }}</b-th>
                              </tr>
                              <b-tr>
                                <b-th>{{ $n(19) }}</b-th>
                                <b-th>{{ $n(20) }}</b-th>
                                <b-th>{{ $n(21) }}</b-th>
                                <b-th>{{ $n(22) }}</b-th>
                                <b-th>{{ $n(23) }}</b-th>
                                <b-th>{{ $n(24) }}</b-th>
                                <b-th>{{ $n(25) }}</b-th>
                                <b-th>{{ $n(26) }}</b-th>
                                <b-th>{{ $n(27) }}</b-th>
                                <b-th>{{ $n(28) }}</b-th>
                                <b-th>{{ $n(29) }}</b-th>
                                <b-th>{{ $n(30) }}</b-th>
                                <b-th>{{ $n(31) }}</b-th>
                                <b-th>{{ $n(32) }}</b-th>
                                <b-th>{{ $n(33) }}</b-th>
                                <b-th>{{ $n(34) }}</b-th>
                                <b-th>{{ $n(35) }}</b-th>
                                <b-th>{{ $n(36) }}</b-th>
                              </b-tr>
                              <b-tr>
                                  <b-td v-for="(item, index) in subServiceTypeList" :key="index">
                                      {{ $n(getPatientNumber(item.value), { useGrouping: false }) }}
                                  </b-td>
                                  <b-td>
                                      {{ $n(report_data.assistance_patient.length, { useGrouping: false }) }}
                                  </b-td>
                                  <b-td>{{ $n(report_data.gender_wise_patient.total_female) }}</b-td>
                                  <b-td>{{ $n(report_data.gender_wise_patient.total_male) }}</b-td>
                                  <b-td>{{ $n(report_data.gender_wise_patient.total_boy) }}</b-td>
                                  <b-td>{{ $n(report_data.gender_wise_patient.total_girl) }}</b-td>
                                  <b-td>{{ $n(report_data.gender_wise_patient.total_girl + report_data.gender_wise_patient.total_boy) }}</b-td>
                                  <b-td>{{ $n(report_data.total_deposit) }}</b-td>
                                  <b-td>{{ $n(report_data.total_expense) }}</b-td>
                                  <b-td>{{ $n(report_data.total_patient) }}</b-td>
                                  <b-td></b-td>
                              </b-tr>
                            </b-table-simple>
                        </b-col>
                    </b-row>
                </b-overlay>
            </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import ExportPdf from './export-pdf'
import RestApi, { hospitalServiceBaseUrl } from '@/config/api_config'
import { burntVictimAssistanceReportApi, assignUserHospitalApi } from '../../../api/routes'
import RouteBasedList from '@/mixins/route-base-list'
import ReportHeading from '@/Utils/report-head'

export default {
  mixins: [RouteBasedList],
  components: {
  },
  data () {
    return {
        sysCall: 0,
        hospitalList: [],
        hospitalIds: [],
        userId: 0,
        hospitalLoad: false,
        unitLoad: false,
        isDisabled: false,
        search: {
            fiscal_year_id: 0,
            division_id: 0,
            district_id: 0,
            hospital_id: 0,
            month_id: 0,
            donate_category: 3
        },
        titleData: {},
        orgId: 3,
        districtList: [],
        report_data: {},
        reportHeadData: null
    }
  },
  computed: {
    subServiceTypeList: function () {
        return this.$store.state.HospitalDisabilityService.commonObj.subServiceTypeList
    },
    divisionList: function () {
        return this.$store.state.commonObj.divisionList.filter(item => item.status === 0)
    },
    monthList () {
      const objectData = this.$store.state.commonObj.monthList
      return objectData.map((obj, key) => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.value, text: obj.text_bn }
        } else {
          return { value: obj.value, text: obj.text_en }
        }
      })
    },
    currentLocale () {
      return this.$i18n.locale
    },
    fiscalYearList: function () {
      return this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
    }
  },
  watch: {
    'search.division_id': function (newVal, oldVal) {
        if (newVal !== oldVal) {
            this.search.hospital_id = 0
            if (newVal !== 0) {
                this.districtList = this.getDistrictList(newVal)
                this.hospitalList = this.getHospitalByDivisionId(newVal)
            } else {
                this.districtList = []
                this.hospitalList = this.getHospitalListAll()
            }
        }
    },
    'search.district_id': function (newVal, oldVal) {
        if (newVal !== oldVal) {
            this.search.hospital_id = 0
            if (newVal !== 0) {
                this.hospitalList = this.getHospitalByDistrictId(newVal)
            } else {
                this.hospitalList = this.getHospitalListAll()
            }
        }
    },
    'search.fiscal_year_id': function (newVal, oldVal) {
        const fiscalYear = this.$store.state.commonObj.fiscalYearList.find(item => item.value === newVal)
        this.search.fiscal_year = fiscalYear.text_en
    },
    currentLocale: function (newVal, oldVal) {
        if (newVal !== oldVal) {
            if (this.search.division_id) {
                this.districtList = this.getDistrictList(this.search.division_id)
                this.hospitalList = this.getHospitalByDivisionId(this.search.division_id)
            }
            if (this.search.district_id) {
                this.hospitalList = this.getHospitalByDistrictId(this.search.district_id)
            }
            if (!this.search.division_id && !this.search.district_id) {
                this.hospitalList = this.getHospitalListAll()
            }
            this.headerName()
        }
    }
  },
  created () {
        this.hospitalLoad = true
        this.headerName()
        var officeId = this.$store.state.Auth.authUser.office_id
        if (officeId > 1) {
            this.userId = this.$store.state.Auth.authUser.user_id
            if (this.userId > 1) {
              this.sysCall = 1
                this.getUserWiseHospital(this.userId)
            }
        } else {
            this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1).map((obj, key) => {
                this.hospitalIds.push(obj.value)
            })
            this.hospitalList = this.getHospitalListAll()
        }
        if (this.$store.state.Auth.activeRoleId !== 1) {
          this.userId = this.$store.state.Auth.authUser.user_id
            if (this.$store.state.Auth.authUser.is_org_admin !== 1) {
              this.getUserWiseHospital(this.userId)
            }
        }
  },
  methods: {
    async getUserWiseHospital (userId) {
        const params = Object.assign({ user_id: userId })
        const result = await RestApi.getData(hospitalServiceBaseUrl, assignUserHospitalApi, params)
        if (result.success) {
                this.hospitalIds = result.data
        } else {
            this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1).map((obj, key) => {
                this.hospitalIds.push(obj.value)
            })
        }
        this.hospitalList = this.getHospitalList()
        if (this.hospitalList.length) {
          this.search.hospital_id = this.hospitalList[0].value
        }
    },
    getHospitalList () {
        let hospitalList = this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1)
        if (this.hospitalIds.length > 0) {
        hospitalList = hospitalList.filter((p) => this.hospitalIds.includes(p.value))
        }
        this.hospitalLoad = false
        return hospitalList
    },
    getMonthName (Id) {
      const obj = this.$store.state.commonObj.monthList.find(item => item.value === Id)
      if (obj === undefined) {
        return ''
      } else {
        return this.$i18n.locale === 'bn' ? obj.text_bn : obj.text_en
      }
    },
    getHospitalName (Id) {
      const obj = this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.find(item => item.value === Id)
      if (obj === undefined) {
        return ''
      } else {
        return this.$i18n.locale === 'bn' ? obj.text_bn : obj.text_en
      }
    },
    getFiscalYearName (fiscalYearId) {
      const obj = this.$store.state.commonObj.fiscalYearList.find(item => item.value === parseInt(fiscalYearId))
      if (obj === undefined) {
        return ''
      } else {
        return this.$i18n.locale === 'bn' ? obj.text_bn : obj.text_en
      }
    },
    getHospitalByDivisionId (divisionId = null) {
       return this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1 && item.division_id === divisionId)
    },
    getHospitalByDistrictId (districtId = null) {
       return this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1 && item.district_id === districtId)
    },
    getHospitalListAll: function () {
      return this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1)
    },
    searchData () {
        this.loadData()
    },
    getDivisionName (Id) {
        const Obj = this.$store.state.commonObj.divisionList.find(item => item.value === parseInt(Id))
        if (this.$i18n.locale === 'bn') {
            return Obj.text_bn
        } else {
            return Obj.text_en
        }
    },
    getDistrictName (Id) {
        const Obj = this.$store.state.commonObj.districtList.find(item => item.value === parseInt(Id))
        if (this.$i18n.locale === 'bn') {
            return Obj.text_bn
        } else {
            return Obj.text_en
        }
    },
    getDistrictList (divisionId = null) {
        const districtList = this.$store.state.commonObj.districtList.filter(item => item.status === 0)
        if (divisionId) {
            return districtList.filter(district => district.division_id === divisionId)
        }
        return districtList
    },
    getExpenseAmount (Id) {
        const expenseList = this.report_data.target_month_expense.filter(el => parseInt(el.sub_service_type_id) === Id)
        const totalExpense = expenseList.length > 0 ? expenseList.reduce((acc, item) => acc + parseFloat(item.amount), 0) : 0
        return totalExpense
    },
    getTotalExpense () {
        const totalExpense = this.report_data.target_month_expense.length > 0 ? this.report_data.target_month_expense.reduce((acc, item) => acc + parseFloat(item.amount), 0) : 0
        return totalExpense
    },
    getPatientNumber (Id) {
        const patientList = this.report_data.assistance_patient.filter(el => parseInt(el.sub_service_type_id) === Id)
        return patientList.length > 0 ? patientList.length : 0
    },
    loadData () {
        try {
            this.isDisabled = true
            this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
            const params = Object.assign({}, this.search)
            RestApi.getData(hospitalServiceBaseUrl, burntVictimAssistanceReportApi, params).then(response => {
                if (response.success) {
                    this.report_data = response.data
                    this.titleData = response.search_field
                } else {
                    this.report_data = {}
                }
                this.unitLoad = true
                this.isDisabled = false
                this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
            })
        } catch (e) {
            this.isDisabled = false
        }
    },
    async headerName () {
        const headData = await ReportHeading.getReportHead(hospitalServiceBaseUrl, 'configuration/report-heading/detail', this.orgId)
        this.reportHeadData = headData
    },
    pdfExport () {
        const reportTitle = this.$t('report_monthly.burnt_victim_monthly_report')
        ExportPdf.exportPdfDetails(hospitalServiceBaseUrl, 'configuration/report-heading/detail', this.orgId, reportTitle, this.report_data, this, this.titleData)
    }
  }
}
</script>
<style scoped lang="scss">
    .reportTitle {
        font-weight: bold;
        border: 1px solid;
        padding: 8px 15px 8px 15px;
        border-radius: 11px;
    }
    .titleDiv {
        margin-top: 1.2rem;
        font-size: 16px;
    }
    .details_report {
        font-size: 8px;
        color: #000;
        h5 {
            color: green !important;
            font-size: 12px !important;
        }
        .table-bordered td:nth-child(2n+1) {
            font-weight: 700;
        }
        .table-bordered th {
            text-align: center;
            font-size: 11px !important;
            // font-weight: 900 !important;
        }
        .table-bordered tr td {
            font-size: 9px !important;
            text-align: center;
        }
    }
    .hidden_header {
        display: none
    }
    .card-border {
        border: 1px solid #b9bdc1;
        box-shadow: 1px 1px 6px -1px grey;
        background-color: #dee2e6;
    }
    [dir=ltr][mode=light] .card-body {
        flex: 1 1 auto;
        min-height: 1px;
        padding: 10px;
    }
</style>
